const style = {
    // Allow divs to be nested in a p-type tag
    p: {
        marginTop: '1em',
        marginBottom: '1em',
        marginLeft: 0,
        marginRight: 0,
    },
    graphic: {
        width: '45%',
        float: 'left',
        margin: '5px',
        padding: '5%',
    },
    instructions: {
        gridColumnStart: 'main',
        gridColumnEnd: 'right',
        gridRowStart: 'main',
        gridRowEnd: 'bottom',
        overflow: 'auto',
        padding: 10,
    },
    usageBlock: {
        padding: '5%',
    },
}

export default style
